module.exports = __webpack_public_path__ + "media/images/emblems/Schoenenwerd_wappen-cea8051c1664e4cfac9f1ac65bafb32d.svg";